// per adesso non utilizzo un database specifico per i barcode perchè dovrei tenerlo aggiornato ad ogni modifica  dei relativi valori
// --> utilizzo una cache per la lettura dei barcode ricorrenti

import configurazioni from './configurazioniService.js'
import prodotti from './prodottiService.js'
import clienti from './clientiService.js'
import fidelity from './fidelityService.js'
const helpers = require('../components/helpers.js')

const LRU = require('lru-cache')
const options = { max: 500, maxAge: 1000 * 60 * 60, updateAgeOnGet: false } // TODO: prevedere comando di svuotamento
const cache = new LRU(options)

var bilance
;(async () => {
  let fb = cache.get('configurazioni_formati_barcode')
  if (!fb) {
    console.log('letta configurazione')
    fb = await configurazioni.getConfigurazione('formati_barcode')
    cache.set('configurazioni_formati_barcode', fb)
  }
  bilance = await configurazioni.getConfigurazione('bilance', 'elenco')
})()

async function getInfoBarcode(searchText, filter) {
  // TODO: Creare tabella con elenco barcode riconosciuti invece di calcolare tipo barcode da formato
  //       Potrebbero essere presenti barcode con lo stesso formato ma per usi diversi
  //       La tabella deve essere alimentata da qualsiasi operazione viene fatta nei prodotti (evento su moleculer ?)
  const cachedValue = cache.get(searchText)
  let codice = ''
  let tipoBarcode = ''
  let obj = null
  if (!cachedValue) {
    console.log('getInfoBarcode: nocache', searchText)
    const result = await confBarcode(searchText, filter)
    if (result.isQrCode) {
      return { tipoBarcode: 'qrcode', tipo: result.tipo, elencoInfo: result.elencoInfo }
    }
    searchText = result.code // ####
    if (result && result.tipo && result.tipo.startsWith('prodotto')) {
      result.tipo = 'prodotto'
    }
    switch (result.tipo) {
      case 'prodotto':
        // TODO: Verificare. Questa situazione è incompatibile con un codice di uguale lunghezza senza caratteri da ignorare
        if (result.codaCaratteriDaIgnorare && result.codaCaratteriDaIgnorare > 0) {
          codice = result.code
        }
        // obj = await prodotti.getInfoFromBarcode(searchText)
        // codice = (obj.ricercaTC || '').toUpperCase() || obj.codice
        // non lo metto in cache, serve solo per sapere di che tipo di barcode si tratta
        break
      case 'tessera': // Verificare se e come gestire...
        obj = await clienti.getCardFromBarcode(searchText)
        codice = obj.codice
        break
      case 'fidelitycard':
      case 'buonomultiuso':
      case 'buonomonouso':
      case 'coupon':
        obj = await fidelity.getFidelity(searchText)
        codice = obj.codice || searchText
        break
      case 'grattaevinci':
        codice = result.code
        result.tipo = result.tipoDestinazione || 'prodotto'
        break
      case 'sbloccoPorta':
        codice = result.code
        break
      default:
        break
    }
    if (codice) {
      const value = `${result.tipo}§§°§${codice}`
      cache.set(searchText, value)
    }
    tipoBarcode = result.tipo || ''
  } else {
    console.log('getInfoBarcode: cache', searchText)
    const values = cachedValue.split('§§°§')
    tipoBarcode = values[0]
    codice = values[1]
  }
  return { tipoBarcode, code: codice }
}

const confBarcode = async function(srcBarcode, filtroEsterno) {
  // separare qrcode in base a lunghezza ?
  let result = { code: srcBarcode }
  let barcode = null
  let fb = cache.get('configurazioni_formati_barcode')
  if (!fb) {
    console.log('letta configurazione')
    fb = await configurazioni.getConfigurazione('formati_barcode')
    cache.set('configurazioni_formati_barcode', fb)
  }

  if (fb && fb.barcode) {
    if (srcBarcode.length > 20) {
      for (const q of fb.qrcode) {
        if (q.lunghezza > 0 && (srcBarcode.length % q.lunghezza) === 0) {
          const elencoInfo = []
          const codici = helpers.chunkString(srcBarcode, q.lunghezza)
          if (q.tipo === 'bilancia') {
            const codiceBilancia = srcBarcode.substring(q.codice.posizione - 1, q.codice.posizione - 1 + q.codice.len)
            const bilancia = bilance.find(x => x.protocollo === q.protocollo && parseInt(x.codiceBilancia) === parseInt(codiceBilancia))
            const generico = bilancia.pluGenerico
            for (const codice of codici) {
              const info = {}
              for (const c of bilancia.qrCode.campi) {
                info[c.tipo] = codice.substring(c.posizione - 1, c.posizione - 1 + c.len)
                if (c.tipo === 'plu') {
                  const plu = bilancia.plu.find(x => parseInt(x.codicePlu) === parseInt(info[c.tipo]))
                  const codiceProdotto = plu ? plu.codiceProdotto : generico.codiceProdotto
                  const tipoValore = plu ? plu.tipo : generico.tipo
                  info.isReparto = plu ? plu.isReparto : generico.isReparto
                  info.codiceProdotto = codiceProdotto
                  info.tipoValore = tipoValore
                }
                if (c.decimali) {
                  info[c.tipo] = +(parseFloat(info[c.tipo]) / Math.pow(10, c.decimali)).toFixed(c.decimali)
                } else if (c.numerico) {
                  info[c.tipo] = parseInt(info[c.tipo])
                }
              }
              elencoInfo.push(info)
            }
            return { isQrCode: true, tipo: 'bilancia', elencoInfo: elencoInfo }
          }
        }
      }
    }
    const filtroLen = fb.barcode.filter(x => (x.lunghezza - ((x.caratteriMancantiLettore && x.caratteriMancantiLettore.length) || 0) + ((x.caratteriAggiuntiLettore && x.caratteriAggiuntiLettore.length) || 0)) === srcBarcode.length || x.lunghezza === 0)
    if (filtroLen) {
      // barcode = filtroLen.find(x => srcBarcode.startsWith(x.prefisso) && x.prefisso.length > 0)
      // Nel caso di barcode che comincia per 0 (e forse altri ..) il lettore toglie una cifra riportando 12 caratteri invece che 13
      // Nella configurazione dei barcode ho aggiunto caratteriMancantiLettore="0"
      barcode = ''
      for (const b of filtroLen) {
        const bbCode = `${b.caratteriMancantiLettore || ''}${srcBarcode}`
        if (bbCode.startsWith(b.prefisso) && b.prefisso.length > 0) { // TODO: considerare eventuale filtro esterno
          barcode = b
          result.code = bbCode
        }
        if (b.codaCaratteriDaIgnorare && b.codaCaratteriDaIgnorare > 0) {
          barcode = b
          result.code = bbCode.slice(0, -b.codaCaratteriDaIgnorare)
        }
        if (b.caratteriAggiuntiLettore && b.caratteriAggiuntiLettore > 0) {
          barcode = b
          result.code = bbCode.substring(b.caratteriAggiuntiLettore.length)
        }
        // }
        if (!barcode) {
          if (filtroEsterno) {
            barcode = filtroLen.find(x => x.prefisso === '' && x.tipo === filtroEsterno)
            if (barcode && filtroEsterno === 'codicefiscale' && barcode.eseguiVerifica) {
              if (helpers.verificaCF(result.code)) {
                barcode = null
              }
            }
            if (barcode && filtroEsterno === 'partitaiva' && barcode.eseguiVerifica) {
              if (helpers.verificaPIva(result.code)) {
                barcode = null
              }
            }
          } else if (!b.prefisso && !b.codaCaratteriDaIgnorare) {
            barcode = b
          }
        }
        if (barcode) {
          if (barcode.substring1) {
            result.code = result.code.substring(barcode.substring0 || 0, barcode.substring1)
          }
          // Se sono presenti più possibilità, devo verificare per ciascuna se trovo il prodotto
          if (b.tipo.startsWith('prodotto') && filtroLen.length > 1) {
            const prodotto = await prodotti.getInfoProdotto(null, '', '', '', 'banco', result.code, false)
            if (!prodotto) {
              continue
            }
          }
          result = { ...result, ...barcode }
          break
        }
      }
    }
  }
  return result
}

const addEANCheckDigit = (numero) => {
  const barcode = String(numero)
  const len = barcode.length
  if (len !== 7 && len !== 12) {
    return '-non valido-'
  }

  let somma = 0
  for (let i = 0; i < len; i++) {
    const peso = (len - i) % 2 === 0 ? 1 : 3
    const digit = barcode.charAt(i)
    somma += parseInt(digit) * peso
    // console.log(peso, digit, somma)
  }
  const checkDgt = Math.ceil(somma / 10) * 10 - somma
  return barcode + String(checkDgt)
}

export default {
  getInfoBarcode,
  addEANCheckDigit
}
